import { useQuery } from "react-query";
import { getViewings } from "@/services/api";
import { useAuth } from "@/shared/hooks/useAuth";
import { Viewing } from "@/services/cms/apiTypes";

function getPropertyViewingDateMap(viewings: Viewing[]) {
  const propertyViewing = new Map<string, Date>();
  viewings.forEach((view) => {
    const viewingDate = new Date(view.viewing_at!);
    const existingDate = propertyViewing.get(view.property.id.toString());
    if (!existingDate || viewingDate < existingDate) {
      propertyViewing.set(view.property.id.toString(), viewingDate);
    }
  });
  return propertyViewing;
}

export const usePropertyUpcomingViewingsDates = () => {
  const { user } = useAuth({ redirectOnUnauth: false });

  return useQuery(
    ["viewings", user?.application_id],
    () => getViewings(user!.application_id, "UPCOMING"),
    {
      retry: false,
      refetchOnWindowFocus: true,
      staleTime: 0,
      enabled: !!user?.application_id,
      select: getPropertyViewingDateMap,
    },
  );
};
